var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pt-4 pb-8",attrs:{"elevation":0}},[_c('v-row',_vm._l((_vm.inputs),function(header,i){return _c('v-col',{key:i,attrs:{"cols":"12","sm":"6"}},[_c('input-global',{attrs:{"params":header}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }